<template>
  <div>
    <div class="event-list" :class="{ 'event-list--loading': isLoading }" >
      <div class="event-list-summary" v-if="currentFilters">
        <span>
          <strong>Filtering:</strong>
          {{ currentFilters }}
        </span>

        <button type="button" @click="clearFilters">Clear Filters</button>
      </div>

      <div class="event-list-groups" v-if="results.groups.length">
        <EventListGroup :key="eventGroup.date" :group="eventGroup" v-for="eventGroup in results.groups"/>
      </div>

      <div class="event-list-empty" v-if="!results.groups.length">
        <p>No events found.</p>
      </div>

      <div class="event-list-actions" v-if="results.has_more">
        <ul class="cta-group ignore-list">
          <li v-if="results.has_more">
            <button type="button" class="btn" @click="loadMore">
              More Events
            </button>
          </li>

          <li v-if="canHide">
            <button type="button" class="btn" @click="clearOffset">
              Hide
            </button>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapMutations, mapGetters } from 'vuex'
import EventListGroup from './EventListGroup'

export default {
  name: 'EventList',

  components: {
    EventListGroup
  },

  computed: {
    ...mapState([
      'results',
      'resultsOffset',
      'isLoading'
    ]),

    ...mapGetters([
      'currentFilters'
    ]),

    canHide() {
      return this.resultsOffset > 0
    }
  },

  methods: {
    ...mapMutations([
      'loadMore',
      'clearFilters',
      'clearOffset'
    ])
  }
}
</script>
